import { Menu } from 'antd'
import React from 'react'
import { useHistory } from 'react-router'
import { IMenuItem, useMenuItems } from '../useMenuItems'
import styles from './Menu.module.scss'
import MenuItem from './MenuItem'

interface IMenuProps {
  siderIsCollapsed: boolean
  className?: string
}

const SidebarMenu: React.FC<IMenuProps> = ({ siderIsCollapsed, className }) => {
  const history = useHistory()
  const { activeMenuItem, menuItems } = useMenuItems()

  const handleClick = (e) => {
    const path = menuItems[e.key]['url']
    if (path) history.push(path)
  }

  return (
    <Menu
      className={`${styles.menu} ${className} ${
        siderIsCollapsed ? styles.menuCollapsed : ''
      }`}
      onClick={handleClick}
      style={{
        width: siderIsCollapsed ? 40 : 'auto',
      }}
      selectedKeys={[activeMenuItem.toString()]}
      mode="inline"
    >
      {menuItems.map((item: IMenuItem, index: number) => (
        <MenuItem
          key={index}
          index={index}
          item={item}
          siderIsCollapsed={siderIsCollapsed}
          totalItems={menuItems.length}
        />
      ))}
    </Menu>
  )
}

export default SidebarMenu
